import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface ScoutTextProps {
  label: string | JSX.Element | null
  labelClass?: string
}

const ScoutText: React.FC<ScoutTextProps> = ({ label, labelClass }) => {
  const { t } = useTranslation()
  return (
    <div className='grid grid-flex grid-justify-space-between'>
      <span className={`grid-item palm-one-whole input-label ${labelClass ?? ''}`}>
        <span>{label}</span>
      </span>
      <span className='grid-item font-body-small-regular font color-text-weak'>
        <span className='font-body-small-bold padding-right-xs palm-padding-right-s'>ScoutText</span>
        <span className='font-body-small-regular'>{t('scoutText', 'for your real estate')}</span>
      </span>
    </div>
  )
}

export default ScoutText
